import React from 'react'
import { Container } from 'react-bootstrap'
import Blog from '../../../Utilitis/Blog/Blog'
import Section from '../../../Utilitis/Section'
import TitleSection from '../../../Utilitis/TitleSection'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function OurBlogs(props) {
    return (
        <Section bg="white">
            <Container>
                <TitleSection text="Our Blogs" center title />
                <OwlCarousel className='owl-theme' {...props.option}  >
                    <div className='item'> <Blog title="Pro eu error molestie deserunt" image="/images/blog01.jpg" /> </div>
                    <div className='item'> <Blog title="Student Award 2021" image="/images/blog04.jpg" /> </div>
                    <div className='item'> <Blog title="Student Award 2021" image="/images/blog04.jpg" /> </div>
                    <div className='item'> <Blog title="Pro eu error molestie deserunt" image="/images/blog01.jpg" /></div>
                    <div className='item'> <Blog title="Pro eu error molestie deserunt" image="/images/blog03.jpg" /></div>
                </OwlCarousel>;
            </Container>
        </Section>
    )
}
